import { useMutation } from '@tanstack/react-query';

import { createOnboardingInput } from '../services';

export function useCreateOnboarding() {
  return useMutation({
    mutationFn: createOnboardingInput,
  });
}
